export default "__VITE_ASSET__BFiJtYsN__"